import { render, staticRenderFns } from "./EvaluateTask.vue?vue&type=template&id=13cebea2&"
import script from "./EvaluateTask.vue?vue&type=script&lang=js&"
export * from "./EvaluateTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports